import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, Quote, ChevronLeft, ChevronRight } from 'lucide-react';

const Testimonials = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: 'Subashini Vasudevan',
      text: 'I am buying from Sasimart for past 5 years, very good service, next day delivery and very fresh fruits and vegetables. I always forget some stuff, then I message them to add, always they have done this, good customer service, I always recommend.',
      rating: 5,
      avatar: 'S',
      color: 'bg-blue-500',
    },
    {
      id: 2,
      name: 'Moorthi Rajamanickam',
      text: 'Excellent service from Sasimart! They responded immediately on WhatsApp, and it was very easy to add additional items through the WhatsApp team. The items were fresh, nicely packaged, and delivered in great condition.',
      rating: 5,
      avatar: 'M',
      color: 'bg-green-500',
    },
    {
      id: 3,
      name: 'Divakar Hariraju',
      text: 'Had a good shopping experience with Sasimart. They have a very good Customer care team that goes above and beyond. Almost every Indian product is available. The staffs are so friendly and helpful.',
      rating: 5,
      avatar: 'D',
      color: 'bg-purple-500',
    },
    {
      id: 4,
      name: 'Keerthivasan R',
      text: 'Top-notch service from start to finish. The team was helpful and made everything easy. Excellent experience with Sasimart. Prompt delivery, very good quality mangoes and friendly communication throughout.',
      rating: 5,
      avatar: 'K',
      color: 'bg-orange-500',
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const next = () => setActiveIndex((prev) => (prev + 1) % testimonials.length);
  const prev = () => setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  return (
    <section className="py-20 bg-gray-900 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }} />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="text-primary-400 font-semibold text-sm uppercase tracking-wider">Testimonials</span>
          <h2 className="text-4xl font-bold text-white mt-2">What Our Customers Say</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-primary-500 to-secondary-500 mx-auto mt-4 rounded-full" />
        </motion.div>

        <div className="max-w-4xl mx-auto relative">
          <AnimatePresence mode="wait">
            <motion.div
              key={activeIndex}
              className="text-center"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.5 }}
            >
              <Quote size={48} className="text-primary-500/30 mx-auto mb-6" />

              <div className="flex justify-center gap-1 mb-8">
                {[...Array(testimonials[activeIndex].rating)].map((_, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, scale: 0 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: i * 0.1 }}
                  >
                    <Star size={24} className="text-yellow-400 fill-yellow-400" />
                  </motion.div>
                ))}
              </div>

              <p className="text-xl md:text-2xl font-light italic leading-relaxed mb-8 text-gray-300 max-w-3xl mx-auto">
                "{testimonials[activeIndex].text}"
              </p>

              <div className="flex items-center justify-center gap-4">
                <div className={`w-14 h-14 ${testimonials[activeIndex].color} rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg`}>
                  {testimonials[activeIndex].avatar}
                </div>
                <div className="text-left">
                  <p className="font-bold text-lg text-white">{testimonials[activeIndex].name}</p>
                  <p className="text-primary-400 text-sm">Verified Customer</p>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-6 mt-12">
            <motion.button
              className="p-3 rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              onClick={prev}
            >
              <ChevronLeft size={24} />
            </motion.button>

            <div className="flex gap-3">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  className={`h-2 rounded-full transition-all duration-500 ${
                    index === activeIndex 
                      ? 'w-10 bg-gradient-to-r from-primary-500 to-secondary-500' 
                      : 'w-2 bg-gray-600 hover:bg-gray-500'
                  }`}
                  onClick={() => setActiveIndex(index)}
                />
              ))}
            </div>

            <motion.button
              className="p-3 rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              onClick={next}
            >
              <ChevronRight size={24} />
            </motion.button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
